export const logout = () => {
  //   localStorage.removeItem("token");
  localStorage.clear()
  window.location.href = '/'
}
